module.exports = __webpack_public_path__ + "static/media/table-sort-default.ccca2398.svg";